import React from "react"
import { graphql } from "gatsby"
import StructuredText from "../custom-structured-text-renderer"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"

const ArticleImage = ({ richContent, image }) => {
  return (
    <section className="article-image">
      <div className="article-image__inner">
        <div className="article-image__content">
          {richContent && <StructuredText data={richContent} />}
        </div>
        <div className="article-image__image">
          {image && <Asset asset={image} />}
        </div>
      </div>
    </section>
  )
}

export default ArticleImage

export const query = graphql`
  fragment ArticleImageProps on DatoCmsArticleImage {
    ... on DatoCmsArticleImage {
      id
      image {
        ...InternalAssetProps
      }
      richContent {
        value
      }
    }
  }
`